exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.md-size-50[data-v-ceeb7586] {\r\n    padding: 0 15px !important;\n}\r\n", ""]);

// exports
